// import { LegalConsent } from '../ConsentList.types';

import {
  LegalConsent,
  ConsentSectionType as LegalConsentSectionType,
  LegalConsentsProps,
} from '../LegalConsents.types';

export const LegalConsentsReponse: LegalConsent[] = [
  {
    id: 'default-consent-for-non-apec',
    name: 'Default Consents for Non APEC contries',
    countries: [
      'CY',
      'CX',
      'ZW',
      'SX',
      'GM',
      'CO',
      'TN',
      'LT',
      'ET',
      'ST',
      'GD',
      'BV',
      'UG',
      'AQ',
      'GU',
      'NG',
      'NU',
      'TW',
      'XI',
      'SA',
      'WS',
      'MV',
      'ES',
      'CZ',
      'TL',
      'VI',
      'BF',
      'JM',
      'NL',
      'IS',
      'PH',
      'TZ',
      'AO',
      'RE',
      'FI',
      'MZ',
      'GT',
      'SK',
      'TO',
      'SY',
      'GY',
      'MX',
      'TM',
      'GF',
      'DZ',
      'MT',
      'LC',
      'JO',
      'EH',
      'GE',
      'TF',
      'ME',
      'MA',
      'AL',
      'WF',
      'EG',
      'RW',
      'IO',
      'GA',
      'XK',
      'TC',
      'SG',
      'SI',
      'GB',
      'BB',
      'VU',
      'XA',
      'ZA',
      'IT',
      'LV',
      'PG',
      'MG',
      'AU',
      'CA',
      'BJ',
      'KY',
      'GP',
      'IQ',
      'BT',
      'VG',
      'MR',
      'HT',
      'AZ',
      'RO',
      'MN',
      'LW',
      'GS',
      'LU',
      'DO',
      'TT',
      'ZM',
      'CM',
      'UK',
      'BE',
      'YT',
      'SD',
      'VA',
      'OM',
      'UA',
      'NA',
      'LS',
      'IR',
      'NI',
      'DK',
      'KI',
      'BD',
      'MW',
      'CL',
      'NC',
      'KW',
      'AW',
      'BH',
      'HU',
      'US',
      'GL',
      'PL',
      'GN',
      'NF',
      'ML',
      'NZ',
      'ID',
      'VE',
      'CV',
      'SV',
      'PA',
      'DE',
      'SO',
      'TG',
      'MC',
      'PS',
      'CC',
      'QA',
      'SZ',
      'FJ',
      'SN',
      'SH',
      'HK',
      'HN',
      'KE',
      'CG',
      'FO',
      'YE',
      'MU',
      'NE',
      'BN',
      'CI',
      'DM',
      'SL',
      'PR',
      'TH',
      'ER',
      'BQ',
      'FK',
      'CR',
      'AF',
      'TD',
      'BR',
      'RU',
      'XB',
      'NP',
      'GR',
      'PE',
      'LR',
      'LP',
      'CF',
      'TJ',
      'BW',
      'PN',
      'LY',
      'TV',
      'FR',
      'GH',
      'LA',
      'KG',
      'IL',
      'CU',
      'AD',
      'CD',
      'NR',
      'BA',
      'MO',
      'UY',
      'BZ',
      'TK',
      'KZ',
      'UV',
      'BO',
      'RS',
      'CH',
      'PT',
      'DJ',
      'NO',
      'MS',
      'CK',
      'HM',
      'AG',
      'KP',
      'PY',
      'AR',
      'LB',
      'MK',
      'SJ',
      'LI',
      'GQ',
      'SE',
      'MY',
      'SR',
      'GW',
      'IN',
      'AI',
      'EC',
      'BS',
      'BY',
      'KN',
      'PK',
      'SB',
      'IE',
      'SC',
      'BM',
      'MD',
      'UZ',
      'CW',
      'EE',
      'KH',
      'PF',
      'HR',
      'AT',
      'VC',
      'HZ',
      'LK',
      'GI',
      'MM',
      'KM',
      'SM',
      'PM',
      'MQ',
      'BI',
      'AE',
      'AM',
      'BG',
    ],
    options: ['hotel-booking-instant-join'],
    sectionType: 'optional' as LegalConsentSectionType,
    index: 1,
    showTopDivider: true,
    showBottomDivider: true,
    containerClassName: '',
    containerClassNameOverride: '',
    onError: '',
    errorClassName: '',
    errorClassNameOverride: '',
    headers: [
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        headerContainerClassName: '',
        headerContainerClassNameOverride: '',
        header: '',
        headerClassName: '',
        headerClassNameOverride: '',
        subHeader: '',
        subHeaderClassName: 'm-subheader',
        subHeaderClassNameOverride: '',
        description: '',
        descriptionClassName: '',
        descriptionClassNameOverride: '',
      },
    ],
    checkboxes: [
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: 'checkbox-first-id',
        isDisabled: false,
        isRequired: false,
        defaultChecked: false,
        showCheckbox: true,
        index: 1,
        name: 'first-chck',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label:
          'I would like to receive personalized communications, including offers, details about promotions, and travel-related products from the Marriott Group via email.',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: 'marriott.com',
        termsLinkLabel: 'Terms',
        termsLinkClassName: 'Terms',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: 'checkbox-second-id',
        isDisabled: false,
        isRequired: false,
        defaultChecked: false,
        showCheckbox: true,
        index: 2,
        name: 'second-chck',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label:
          'I would like for the Marriott Group to share my personal data with Authorized Licensees, as defined in the Global Privacy Statement so I may receive offers and marketing via email.',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: '',
        termsLinkLabel: 'Terms',
        termsLinkClassName: '',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: '',
        isDisabled: false,
        isRequired: false,
        defaultChecked: false,
        showCheckbox: false,
        index: 99,
        name: 'consent-statement-for-US',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label:
          'By signing up, I agree to Marriott\'s\u0026nbsp;\u003ca href="/about/terms-of-use-modal.mi"\u003eTerms of Use\u003c/a\u003e,\u0026nbsp;\u003ca href="/marriott/privacy-modal.mi" target="_self"\u003ePrivacy Statement\u003c/a\u003e, \u003ca href="/marriott-rewards/data-protection.mi" target="_self"\u003eData Protection Clause\u003c/a\u003e\u003c/u\u003e and acknowledge the \u003ca href="/about/ccpa/modal.mi" target="_self"\u003eCalifornia Notice of Financial Incentive\u003c/a\u003e.\u003c/p\u003e\r\n',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: 'marriott.com',
        termsLinkLabel: 'Terms',
        termsLinkClassName: 'Terms',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
    ],
  },
  {
    id: 'optionalConsent-of-japan-and-vietnam-for-booking-instant-join',
    name: 'Optional Consents of Japan and Vietnam for booking instant join',
    countries: ['JP', 'VN'],
    options: ['hotel-booking-instant-join'],
    sectionType: 'optional' as LegalConsentSectionType,
    index: 1,
    showTopDivider: true,
    showBottomDivider: true,
    containerClassName: '',
    containerClassNameOverride: '',
    onError: '',
    errorClassName: '',
    errorClassNameOverride: '',
    headers: [
      {
        forCountries: ['VN'],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        headerContainerClassName: '',
        headerContainerClassNameOverride: '',
        header: '',
        headerClassName: '',
        headerClassNameOverride: '',
        subHeader: 'Don’t miss account updates, program news and exclusive savings offers.',
        subHeaderClassName: '',
        subHeaderClassNameOverride: '',
        description: '',
        descriptionClassName: '',
        descriptionClassNameOverride: '',
      },
    ],
    checkboxes: [
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: '',
        isDisabled: false,
        isRequired: true,
        defaultChecked: false,
        showCheckbox: true,
        index: 1,
        name: '',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label:
          'I would like to receive personalized communications, including offers, details about promotions, and travel-related products from the Marriott Group via email.',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: '',
        termsLinkLabel: 'Terms',
        termsLinkClassName: '',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: '',
        isDisabled: false,
        isRequired: true,
        defaultChecked: false,
        showCheckbox: true,
        index: 2,
        name: '',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label:
          'I would like for the Marriott Group to share my personal data with Authorized Licensees, as defined in the Global Privacy Statement so I may receive offers and marketing via email.',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: '',
        termsLinkLabel: 'Terms',
        termsLinkClassName: '',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
    ],
  },
  {
    id: 'required-consents-of-japan-for-booking',
    name: 'Required consents of japan for booking',
    countries: ['JP'],
    options: ['hotel-booking', 'hotel-booking-instant-join', 'sinup-page'],
    sectionType: 'required' as LegalConsentSectionType,
    index: 1,
    showTopDivider: true,
    showBottomDivider: true,
    containerClassName: '',
    containerClassNameOverride: '',
    onError: '',
    errorClassName: '',
    errorClassNameOverride: '',
    headers: [
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        headerContainerClassName: '',
        headerContainerClassNameOverride: '',
        header: '',
        headerClassName: '',
        headerClassNameOverride: '',
        subHeader: '',
        subHeaderClassName: '',
        subHeaderClassNameOverride: '',
        description: '',
        descriptionClassName: '',
        descriptionClassNameOverride: '',
      },
    ],
    checkboxes: [
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: 'requiredConsent-cnCrossBorderPersonalDataRequired',
        isDisabled: false,
        isRequired: true,
        defaultChecked: false,
        showCheckbox: true,
        index: 1,
        name: '',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label:
          'By making a reservation, I agree to my personal data being collected, used, shared with third parties, and transferred globally in accordance with Marriott’s <a href="/marriott/privacy-modal.mi" target="_self">Global Privacy Statement</a>. I understand that my personal data may be transferred to locations in which <a href="/about/privacy/marriott-group/modal.mi" target="_self">Marriott Group</a> entities are located, and that I may refer to the <a href="https://www.ppc.go.jp/personalinfo/legal/kaiseihogohou/#gaikoku" target="_self" class="external-site">PPC’s website<span aria-hidden="true" class="t-icon-external-site"></span></a> for more information about data protection in various locations.',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: '',
        termsLinkLabel: 'Terms',
        termsLinkClassName: '',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
    ],
  },
  {
    id: 'required-consents-of-vietnam-for-booking',
    name: 'Required consents of vietnam for booking',
    countries: ['VN'],
    options: ['hotel-booking'],
    sectionType: 'required' as LegalConsentSectionType,
    index: 1,
    showTopDivider: true,
    showBottomDivider: true,
    containerClassName: '',
    containerClassNameOverride: '',
    onError: '',
    errorClassName: '',
    errorClassNameOverride: '',
    headers: [
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        headerContainerClassName: '',
        headerContainerClassNameOverride: '',
        header: 'Required Consents',
        headerClassName: '',
        headerClassNameOverride: '',
        subHeader:
          'By ticking the boxes below, I acknowledge and understand that the following required consents are necessary to make a reservation.',
        subHeaderClassName: '',
        subHeaderClassNameOverride: '',
        description: '',
        descriptionClassName: '',
        descriptionClassNameOverride: '',
      },
    ],
    checkboxes: [
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: 'requiredConsent-vnPersonalDataRequired',
        isDisabled: false,
        isRequired: true,
        defaultChecked: false,
        showCheckbox: true,
        index: 1,
        name: 'vnPersonalDataRequired',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label:
          'I have read and agreed to Marriott’s <a href="/about/terms-of-use-modal.mi" target="_self">Terms of Use</a> and my personal data being collected, used, shared and transferred in accordance with Marriott’s <a href="/marriott/privacy-modal.mi" target="_self">Global Privacy Statement</a>. (Required)',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: '',
        termsLinkLabel: 'Terms',
        termsLinkClassName: '',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: 'requiredConsent-vnCrossBorderPersonalDataRequired',
        isDisabled: false,
        isRequired: true,
        defaultChecked: false,
        showCheckbox: true,
        index: 1,
        name: 'vnCrossBorderPersonalDataRequired',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label:
          'I agree to the cross-border transfer of my personal data to the <a href="/about/privacy/marriott-group/modal.mi" target="_self">Marriott Group</a> for the purposes described in Marriott’s <a href="/marriott/privacy-modal.mi" target="_self">Global Privacy Statement</a>, including the completion of my reservation and the provision of hotel accommodation and related services. (Required)',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: '',
        termsLinkLabel: 'Terms',
        termsLinkClassName: '',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
    ],
  },
  {
    id: 'optionalConsent-of-china-for-booking-instand-join',
    name: 'Optional consents of china for booking instand join',
    countries: ['CN'],
    options: ['hotel-booking-instant-join'],
    sectionType: 'optional' as LegalConsentSectionType,
    index: 1,
    showTopDivider: true,
    showBottomDivider: true,
    containerClassName: '',
    containerClassNameOverride: '',
    onError: '',
    errorClassName: '',
    errorClassNameOverride: '',
    headers: [
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        headerContainerClassName: '',
        headerContainerClassNameOverride: '',
        header: '',
        headerClassName: '',
        headerClassNameOverride: '',
        subHeader: 'Don’t miss account updates, program news and exclusive savings offers.',
        subHeaderClassName: '',
        subHeaderClassNameOverride: '',
        description:
          'I understand that updates, news, and offers may be provided through email, text messages, push notices, app alerts, social media, direct mail, and other channels. I am aware that I can unsubscribe or change my preferences at any time in accordance with the <a title="Follow link" href="/about/privacy/mainland-china/modal.mi">Mainland China Privacy Statement</a></u>.',
        descriptionClassName: '',
        descriptionClassNameOverride: '',
      },
    ],
    checkboxes: [
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: '',
        isDisabled: false,
        isRequired: true,
        defaultChecked: false,
        showCheckbox: true,
        index: 1,
        name: '',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label: 'I would like to receive account updates, program news and offers from the Marriott Group.',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: '',
        termsLinkLabel: 'Terms',
        termsLinkClassName: '',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: '',
        isDisabled: false,
        isRequired: true,
        defaultChecked: false,
        showCheckbox: true,
        index: 2,
        name: '',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label: 'I would like to receive exclusive offers from select third parties.',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: '',
        termsLinkLabel: 'Terms',
        termsLinkClassName: '',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
    ],
  },
  {
    id: 'required-consents-of-china-for-booking-instand-join',
    name: 'Required consents of china for booking instand join',
    countries: ['CN'],
    options: ['hotel-booking-instant-join'],
    sectionType: 'required' as LegalConsentSectionType,
    index: 1,
    showTopDivider: true,
    showBottomDivider: true,
    containerClassName: '',
    containerClassNameOverride: '',
    onError: '',
    errorClassName: '',
    errorClassNameOverride: '',
    headers: [
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        headerContainerClassName: '',
        headerContainerClassNameOverride: '',
        header: 'Required Consents',
        headerClassName: '',
        headerClassNameOverride: '',
        subHeader: 'To continue, please carefully read and provide your consent to the following:',
        subHeaderClassName: '',
        subHeaderClassNameOverride: '',
        description: '',
        descriptionClassName: '',
        descriptionClassNameOverride: '',
      },
    ],
    checkboxes: [
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: 'requiredConsent-cnPersonalDataRequired',
        isDisabled: false,
        isRequired: true,
        defaultChecked: false,
        showCheckbox: true,
        index: 1,
        name: 'cnPersonalDataRequired',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label:
          'By signing up, I agree to the Marriott Group’s <a href="/about/terms-of-use-modal.mi" target="_self" class="popup-triggered">Terms of Use</a> and <a href="/loyalty/terms.mi" target="_self">Loyalty Program Terms & Conditions</a>, and to the Marriott Group’s processing of my personal data in accordance with the <a href="/about/privacy/mainland-china/modal.mi" target="_self">Mainland China Privacy Statement</a>.',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: '',
        termsLinkLabel: 'Terms',
        termsLinkClassName: '',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: 'requiredConsent-cnCrossBorderPersonalDataRequired',
        isDisabled: false,
        isRequired: true,
        defaultChecked: false,
        showCheckbox: true,
        index: 2,
        name: 'cnCrossBorderPersonalDataRequired',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label:
          'I agree to the cross-border transfer of my personal data to the <a href="/about/privacy/marriott-group-china/modal.mi" target="_self">Marriott Group</a> for the purposes described in Marriott’s <a href="/about/privacy/mainland-china/modal.mi" target="_self">Mainland China Privacy Statement</a>, including my enrollment in Marriott Bonvoy and my receipt of membership services and related benefits. I understand that I may contact the Marriott Group via the <a href="/about/privacy/mainland-china/contact-us/modal.mi" target="_self">contact details</a> listed in the Mainland China Privacy Statement.',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: '',
        termsLinkLabel: 'Terms',
        termsLinkClassName: '',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
    ],
  },
  {
    id: 'required-consents-of-china-for-booking',
    name: 'Required consents of china for booking',
    countries: ['CN'],
    options: ['hotel-booking'],
    sectionType: 'required' as LegalConsentSectionType,
    index: 1,
    showTopDivider: true,
    showBottomDivider: true,
    containerClassName: '',
    containerClassNameOverride: '',
    onError: '',
    errorClassName: '',
    errorClassNameOverride: '',
    headers: [
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        headerContainerClassName: '',
        headerContainerClassNameOverride: '',
        header: 'Required Consents',
        headerClassName: '',
        headerClassNameOverride: '',
        subHeader: 'To continue, please carefully read and provide your consent to the following:',
        subHeaderClassName: '',
        subHeaderClassNameOverride: '',
        description: '',
        descriptionClassName: '',
        descriptionClassNameOverride: '',
      },
    ],
    checkboxes: [
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: 'requiredConsent-cnPersonalDataRequired',
        isDisabled: false,
        isRequired: true,
        defaultChecked: false,
        showCheckbox: true,
        index: 1,
        name: 'cnPersonalDataRequired',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label:
          'By signing up, I agree to the Marriott Group’s <a href="/about/terms-of-use-modal.mi" target="_self" class="popup-triggered">Terms of Use</a> and <a href="/loyalty/terms.mi" target="_self">Loyalty Program Terms & Conditions</a>, and to the Marriott Group’s processing of my personal data in accordance with the <a href="/about/privacy/mainland-china/modal.mi" target="_self">Mainland China Privacy Statement</a>.',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: '',
        termsLinkLabel: 'Terms',
        termsLinkClassName: '',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: 'requiredConsent-cnCrossBorderPersonalDataRequired',
        isDisabled: false,
        isRequired: true,
        defaultChecked: false,
        showCheckbox: true,
        index: 2,
        name: 'cnCrossBorderPersonalDataRequired',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label:
          'I agree to the cross-border transfer of my personal data to the <a href="/about/privacy/marriott-group-china/modal.mi" target="_self">Marriott Group</a> for the purposes described in Marriott’s <a href="/about/privacy/mainland-china/modal.mi" target="_self">Mainland China Privacy Statement</a>',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: '',
        termsLinkLabel: 'Terms',
        termsLinkClassName: '',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
    ],
  },
  {
    id: 'privacy-consents-of-south-korea-for-booking-instand-join',
    name: 'Privacy consents of south korea for booking instand join',
    countries: ['KR'],
    options: ['hotel-booking-instant-join'],
    sectionType: 'agreeAll' as LegalConsentSectionType,
    index: 1,
    showTopDivider: true,
    showBottomDivider: true,
    containerClassName: '',
    containerClassNameOverride: '',
    onError: '',
    errorClassName: '',
    errorClassNameOverride: '',
    headers: [
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        headerContainerClassName: '',
        headerContainerClassNameOverride: '',
        header: 'Privacy Consents',
        headerClassName: '',
        headerClassNameOverride: '',
        subHeader: '',
        subHeaderClassName: '',
        subHeaderClassNameOverride: '',
        description: '',
        descriptionClassName: '',
        descriptionClassNameOverride: '',
      },
    ],
    checkboxes: [
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: 'agreeAll-agreeAllConsent',
        isDisabled: false,
        isRequired: true,
        defaultChecked: false,
        showCheckbox: true,
        index: 1,
        name: 'agreeAllConsent',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label:
          'By signing up, I agree to Marriott\'s <a href="/about/terms-of-use-modal.mi" target="_self">Terms of Use</a> and Marriott Bonvoy <a href="/loyalty/terms.mi" target="_self">Terms and Conditions</a> and confirm that I am 16 years or older.',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: '/loyalty/terms/privacy/collectionUsePersonalData.mi',
        termsLinkLabel: 'Terms',
        termsLinkClassName: '',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
    ],
  },
  {
    id: 'required-consents-of-south-korea-for-booking-instand-join',
    name: 'Required consents of south korea for booking instand join',
    countries: ['KR'],
    options: ['hotel-booking-instant-join', 'hotel-booking'],
    sectionType: 'required' as LegalConsentSectionType,
    index: 2,
    showTopDivider: true,
    showBottomDivider: true,
    containerClassName: '',
    containerClassNameOverride: '',
    onError: '',
    errorClassName: '',
    errorClassNameOverride: '',
    headers: [
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        headerContainerClassName: '',
        headerContainerClassNameOverride: '',
        header: 'Required Consents',
        headerClassName: '',
        headerClassNameOverride: '',
        subHeader: '',
        subHeaderClassName: '',
        subHeaderClassNameOverride: '',
        description:
          'I understand that the following required consents are necessary to successfully make this reservation.',
        descriptionClassName: '',
        descriptionClassNameOverride: '',
      },
    ],
    checkboxes: [
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: 'requiredConsent-collectPersonalDataConsentRequired',
        isDisabled: false,
        isRequired: true,
        defaultChecked: false,
        showCheckbox: true,
        index: 1,
        name: 'collectPersonalDataConsentRequired',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label: 'Consent to collection and use of Personal Data (Required)',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: '/loyalty/terms/privacy/collectionUsePersonalData.mi',
        termsLinkLabel: 'Terms',
        termsLinkClassName: '',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: 'requiredConsent-cnCrossBorderPersonalDataRequired',
        isDisabled: false,
        isRequired: true,
        defaultChecked: false,
        showCheckbox: true,
        index: 2,
        name: 'cnCrossBorderPersonalDataRequired',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label: 'Consent to provision and cross-border provision of Personal Data (Required)',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: '',
        termsLinkLabel: 'Terms',
        termsLinkClassName: '',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
    ],
  },
  {
    id: 'optionalConsent-of-south-korea-for-booking',
    name: 'Optional consents of south korea for booking',
    countries: ['KR'],
    options: ['hotel-booking-instant-join'],
    sectionType: 'optional' as LegalConsentSectionType,
    index: 3,
    showTopDivider: true,
    showBottomDivider: true,
    containerClassName: '',
    containerClassNameOverride: '',
    onError: '',
    errorClassName: '',
    errorClassNameOverride: '',
    headers: [
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        headerContainerClassName: '',
        headerContainerClassNameOverride: '',
        header: '',
        headerClassName: '',
        headerClassNameOverride: '',
        subHeader: 'Don’t miss account updates, program news and exclusive savings offers.',
        subHeaderClassName: '',
        subHeaderClassNameOverride: '',
        description:
          'I understand by providing all of the optional consents below, I can receive information relating to offers or promotions from the Marriott Group and third parties. I understand that I may deny consent, in which case I may be unable to receive such information. However, other products and services provided by the Marriott Group will continue to be available.',
        descriptionClassName: '',
        descriptionClassNameOverride: '',
      },
    ],
    checkboxes: [
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: 'optionalConsent-collectPersonalDataConsentOptional',
        isDisabled: false,
        isRequired: true,
        defaultChecked: false,
        showCheckbox: true,
        index: 1,
        name: 'collectPersonalDataConsentOptional',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label: 'Consent to collection and use of Personal Data for marketing purposes (Optional)',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: '/loyalty/terms/privacy/personalDataUseMarketing.mi',
        termsLinkLabel: 'Terms',
        termsLinkClassName: '',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: 'optionalConsent-personalDataProvisionConsentOptional',
        isDisabled: false,
        isRequired: true,
        defaultChecked: false,
        showCheckbox: true,
        index: 2,
        name: 'personalDataProvisionConsentOptional',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label: 'Consent to provision of Personal Data to third parties for marketing purposes (Optional)',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: '/loyalty/terms/privacy/provisionDataUseMarketing.mi',
        termsLinkLabel: 'Terms',
        termsLinkClassName: '',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: 'optionalConsent-crossBorderPersonalDataOptional',
        isDisabled: false,
        isRequired: true,
        defaultChecked: false,
        showCheckbox: true,
        index: 3,
        name: 'crossBorderPersonalDataOptional',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label: 'Consent to cross-border transfer of Personal Data for marketing purposes (Optional)',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: '/loyalty/terms/privacy/consentCrossBorderuseMarketing.mi',
        termsLinkLabel: 'Terms',
        termsLinkClassName: '',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
      {
        forCountries: [],
        excludeCountries: [],
        forOptions: [],
        excludeOptions: [],
        id: 'optionalConsent-electronicMarketingConsentOptional',
        isDisabled: false,
        isRequired: true,
        defaultChecked: false,
        showCheckbox: true,
        index: 4,
        name: 'electronicMarketingConsentOptional',
        checkboxClassName: 'm-checkbox-class',
        checkboxClassNameOverride: '',
        label: 'Consent to electronic receipt of marketing information (Optional)',
        labelClassName: '',
        labelClassNameOverride: '',
        termsLink: '/loyalty/terms/privacy/consentMarketingChannel.mi',
        termsLinkLabel: 'Terms',
        termsLinkClassName: '',
        termsLinkClassNameOverride: '',
        onError: '',
        errorLabel: '<span>This is required checkbox</span>',
        errorClassName: '',
        errorClassNameOverride: '',
      },
    ],
  },
];

export const mockLegalConsentResponse: LegalConsentsProps = {
  consentsState: { list: [], sectionTypes: {}, checkboxesState: {} },
  local: 'US',
  countryCode: 'US',
  option: 'hotel-booking-instant-join',
  isValidateErrors: false,
};
